import React from 'react'
import { useAuth } from '@polvo-labs/react-auth'
import { Switch, Route, Redirect } from 'react-router-dom'
import routes from '../../config/routes'
import { Container, Layout } from './styles'
import isAdmin from '../../utils/is-admin'
import Header from '../../components/Header/Admin'
import isCommon from '../../utils/is-common'
import Sidebar from '../../components/Sidebar/Admin'
import { ThemeProvider, adminTheme } from '../../config/theme'
import { createGlobalStyle } from 'styled-components'

interface Props {

}

const GlobalStyles = createGlobalStyle`

`

const AdminArea: React.FC<Props> = () => {
  const { authenticated, user } = useAuth()

  if (!authenticated || isCommon(user)) {
    return (
      <Redirect
        to={routes.index.path}
      />
    )
  } 

  return (
    <ThemeProvider
      theme={adminTheme}
    >
      <React.Fragment>
        <GlobalStyles />
        <Layout>
          <Sidebar />

          <Container
            style={{
              paddingTop: 0,
              margin: 0,
              maxWidth: 'unset',
              position: 'relative',
              overflowY: 'auto',
              height: '100vh',
            }}
          >
            <Header />

            <Switch>
              {isAdmin(user) && (
                <Route
                  path={routes.admin.user.edit.path}
                  component={routes.admin.user.edit.component}
                />
              )}
              {isAdmin(user) && (
                <Route
                  path={routes.admin.user.create.path}
                  component={routes.admin.user.create.component}
                />
              )}
              {isAdmin(user) && (
                <Route
                  path={routes.admin.realty.edit.path}
                  component={routes.admin.realty.edit.component}
                />
              )}

              <Route
                path={routes.admin.chat.path}
                component={routes.admin.chat.component}
              />
              <Route
                path={routes.admin.realty.show.path}
                component={routes.admin.realty.show.component}
              />
              <Route
                path={routes.admin.realty.index.path}
                component={routes.admin.realty.index.component}
              />
              <Route
                path={routes.admin.user.show.path}
                component={routes.admin.user.show.component}
              />
              <Route
                path={routes.admin.user.index.path}
                component={routes.admin.user.index.component}
              />
              <Route
                path={routes.admin.index.path}
                component={routes.admin.index.component}
              />
              <Route
                path={routes.account_activation.path}
                component={routes.account_activation.component}
              />
            </Switch>
          </Container>
        </Layout>
      </React.Fragment>
    </ThemeProvider>
  )
}

export default AdminArea
